export enum AuthenticationProvider {
  GOOGLE = 'google.com',
  MICROSOFT = 'microsoft.com',
  PASSWORD = 'password',
}

export type ApiAuthenticationProviderTypes =
  | ApiAuthenticationProviderEnum.GOOGLE
  | ApiAuthenticationProviderEnum.PASSWORD
  | ApiAuthenticationProviderEnum.MICROSOFT;

export enum ApiAuthenticationProviderEnum {
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  PASSWORD = 'PASSWORD',
}
